export default "__VITE_ASSET__TfprR8Cf__"